import React from 'react';
import styled from 'styled-components';
import { addSubdirectoryToPath } from '../util/getConfig';

export const FooterImage = styled.div`

    padding: 1em;
    width: 560px;
    display: flex;
    justify-content: space-between;
    /* width: 20%; */
    margin: 1em auto;
    align-items: end;

    @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
        box-sizing: border-box;
        width: 100%;
        max-width: 440px;
        height: auto;
        padding: 0.5em 0.5em 0.5em 1em;
        flex-direction: column;
        justify-content: flex-start;
        align-items: start;
        overflow-x: hidden;
        gap: 0.5em;
    }
`;

export const FooterImageLeft = styled.img`
  width: 320px;

  @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
    width: min(100%, 280px);
    height: auto;
  }
`;

export const FooterImageRight = styled.img`
  width: 164px;

  @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
    width: min(100%, 144px);
    height: auto;
  }
`;


export default function FooterInfo() {
    const info1 = addSubdirectoryToPath('/meta/images/alma-info-1.png');
    const info2 = addSubdirectoryToPath('/meta/images/alma-info-2.png');

    return (

      <FooterImage>
        <FooterImageLeft src={info1} />
        <FooterImageRight src={info2} />
      </FooterImage>

    );
}
